export const MESSAGE_TOOLS_CLASS_NAME = 'ai-chat-message-tools';

export const COPY_ICON_SIZE = 14;
